module.exports = __webpack_public_path__ + "img/Brest.8e73e524.png";